import { useResources } from "../../hooks/useResources";
import type { StatusCardData } from "../../interfaces/componentInterfaces/jobDetails";
import ContentHeader from "../contentHeader/ContentHeader";
import StatusCardsGrid from "./StatusCardsGrid";

interface JobDetailsInfoProps {
  userEmail: string;
  fileName: string;
  uploadDate: string;
  subject: string;
  questionsNumber: number;
  requiresGraphics: string;
  publishedQuestions: number;
  statusCards: StatusCardData[];
  onPreview: (type: string) => void;
  onDownload: (type: string) => void;
  onDownloadLog: (cardType: string) => void;
  onDownloadZip: (cardType: string) => void;
}

const JobDetailsInfo = ({
  userEmail,
  fileName,
  uploadDate,
  subject,
  questionsNumber,
  requiresGraphics,
  publishedQuestions,
  statusCards,
  onPreview,
  onDownload,
  onDownloadLog,
  onDownloadZip,
}: JobDetailsInfoProps) => {

  const { getResourceValue } = useResources();

  return (
    <div className="job-details__info-section">
      <div className="job-details__info-container">
        <ContentHeader
          title={getResourceValue("job_details_title", "Job Details")}
          headingLevel={2}
          showActions={false}
          className="content-header--section-title"
        />
        <div className="job-details__info-grid">
          <div className="job-details__info-item">
            <span className="job-details__info-label">
              {getResourceValue("user_email", "User Email:")}
            </span>
            <span className="job-details__info-value">{userEmail}</span>
          </div>
          <div className="job-details__info-item">
            <span className="job-details__info-label">
              {getResourceValue("file_name", "File Name:")}
            </span>
            <span className="job-details__info-value">{fileName}</span>
          </div>
          <div className="job-details__info-item">
            <span className="job-details__info-label">
              {getResourceValue("upload_date_time", "Upload Date and Time:")}
            </span>
            <span className="job-details__info-value">{uploadDate}</span>
          </div>
          <div className="job-details__info-item">
            <span className="job-details__info-label">
              {getResourceValue("subject", "Subject")}
            </span>
            <span className="job-details__info-value">{subject}</span>
          </div>
          <div className="job-details__info-item">
            <span className="job-details__info-label">
              {getResourceValue("questions_number", "Questions Number:")}
            </span>
            <span className="job-details__info-value">{questionsNumber}</span>
          </div>
          <div className="job-details__info-item">
            <span className="job-details__info-label">
              {getResourceValue("requires_graphics", "Requires Graphics:")}
            </span>
            <span className="job-details__info-value">{requiresGraphics}</span>
          </div>
          <div className="job-details__info-item">
            <span className="job-details__info-label">
              {getResourceValue(
                "published_questions_label",
                "Published Questions:"
              )}
            </span>
            <span className="job-details__info-value">
              {publishedQuestions}
            </span>
          </div>
        </div>
      </div>
      <StatusCardsGrid
        cards={statusCards}
        onPreview={onPreview}
        onDownload={onDownload}
        onDownloadLog={onDownloadLog}
        onDownloadZip={onDownloadZip}
      />
    </div>
  );
};

export default JobDetailsInfo;
